(function (){
    'use strict';
    angular.module('app').controller('EditProfileController', EditProfileController);

    EditProfileController.$inject =[
        '$rootScope',
        '$window',
        'toastr',
        '$scope',
        '$location',
        '$routeParams',
        'AffiliatePromoCodeTableService',
        'AffiliateReferredClientsTableService',
        'AffiliateService'
    ]

    function EditProfileController($rootScope,$window,toastr,$scope,$location,$routeParams,AffiliatePromoCodeTableService,AffiliateReferredClientsTableService,AffiliateService) {
        const vm = this;
        vm.role = $rootScope.GlobalProfile.permissionGroup.roles.find(permission => permission.code ==  'ROLE_COMPANY_ADMIN' ||  permission.code =='ROLE_ADMIN')

        vm.marketingCompany= angular.copy(vm.marketingCompany);
        vm.paramsId = $routeParams.id;  
        $scope.form ={};
        vm.goBack = function(){
            $location.path('/affiliates-sales');
        };

        $scope.accounts = function(){
            $location.path('/affiliates-sales/accounts/'+vm.paramsId);
        };

        $scope.financialSummary = function(){
            $location.path('/affiliates-sales/summary/'+vm.paramsId);
        };

        vm.onSubmit = function(form){
            if(form.$invalid){
                for(let field of $scope.form.$error.required){
                    if(field.$name){
                        $scope.form[field.$name].$touched = true
                    }
                }
                toastr.warning('Please check the form!'); 
                $window.scrollTo(0, 0);
               return;
            }
            updateDetails();
        };
        vm.refresh = function(){
            vm.actions = new AffiliatePromoCodeTableService();
            vm.actions.refreshTable();
        }

        init();

        function init(){
           
            getCompanyInformation();
            $scope.promoCodeTableData = new AffiliatePromoCodeTableService().tableData;
            $scope.referredclientsData = new AffiliateReferredClientsTableService().tableData;
        }

        function getCompanyInformation(){
            AffiliateService.getCompanyDetails(
                res=>{
                    vm.marketingCompany = res;
                    vm.location = res.location;
                },
                err=>{
                    toastr.error(err.message);
                    console.log(err);
                },
                vm.paramsId
            );
        }

        function updateDetails(){
            vm.loading =true;
            vm.marketingCompany.locationId = vm.location.id;
            delete vm.marketingCompany.location;
            AffiliateService.updateCompanyDetails(vm.paramsId,
                res=>{
                    toastr.success('Successfully Save!','Success');
                    vm.loading = false;
                },
                err=>{
                    toastr.error(err.message,'Error');
                },
                vm.marketingCompany
            );
        }
    }

})();


// WEBPACK FOOTER //
// ./js/controllers/affiliate-sale/EditProfileController.js